<template id="scart">
  <li class="dropdown"><img class="img-responsive whiteThumb" src="@/images/cartnew.png" alt=""><img class="img-responsive greyThumb" src="@/images/grey2.png" alt="">
    <!--a href="../cart/index.html" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">{{header_text.cart}}<span class="prductNumber">01</span><span class="caret hidden"></span></a-->
    <a v-if="mode == 'spage'" v-on:click="goCart($event)" href="javascript:void(0)">{{header_text.cart}}<span v-if="products != null && products.length > 0" class="prductNumber">{{products.length | format('00')}}</span><span class="caret hidden"></span></a>
    <a v-else href="../cart/index.html">{{header_text.cart}}<span v-if="products != null && products.length > 0" class="prductNumber">{{products.length | format('00')}}</span><span class="caret hidden"></span></a>
    <ul class="dropdown-menu hidden" v-if="products != null">
      <li v-for="(product) in products" v-bind:key="product"><a href="javascript:void(0)" v-if="product.pdetails">{{product.pdetails.product_name}}</a></li>
    </ul>
  </li>
</template>

<script>

import utils from './Utils.vue'
import orderProduct from './OrderProduct.vue'
import cart from './Cart.vue'
import Vue from 'vue'
import VueResource from 'vue-resource'
import VueCookie from 'vue-cookie';
Vue.use(VueResource);
Vue.use(VueCookie);

export default {
  extends: 'cart',
  name: 'scart',
  props:['name', 'countries', 'header_text', 'mode'],
  data () {
    return {
      locale:null,
      products:[],
      token:null,
      submitted:false,
      error:{}
    }
  },
  components: {
  },
  methods: {
    goCart:function(evt) {
      this.$root.$emit('godirect', 'cart');
    },
    setItem:function(item) {
    },
    save:function() {
      var storage = new Array();
      for (var i=0;i<this.products.length;i++) {
        if (this.products[i].pdetails) {
          storage.push({"product_id":this.products[i].pdetails.product_id, "oqty":this.products[i].oqty});
        } else {
          storage.push({"product_id":this.products[i].product_id, "oqty":this.products[i].oqty});
        }
      }
      utils.setCartStorage(storage);
    },
    delAllItems:function() {
      Vue.http.delete(utils.getServerPath()+'/cart/upd.is?deleteall=true').then(response => {
        if (response.body.cart != null) {
          this.$root.$emit('cart', {'action':'deleted', 'cart':response.body.cart});
        } else {
          this.$root.$emit('cart', {'action':'deleted'});
        }
      });
    },
    delItem:function(product_id) {
      Vue.http.delete(utils.getServerPath()+'/cart/upd.is?product_id='+product_id).then(response => {
        if (response.body.cart != null) {
          this.$root.$emit('cart', {'action':'deleted', 'cart':response.body.cart});
        } else {
          this.$root.$emit('cart', {'action':'deleted'});
        }
      });
    },
    getCart:function() {
      Vue.http.get(utils.getServerPath()+'/cart/data.is').then(response => {
        this.$root.$emit('cart', {'action':'loaded', 'cart':response.body.cart});
      });
    },
    updItem:function(product_id, refresh) {
      var formdata = new FormData();
      var cc = utils.getCartStorage();
      var aqty = utils.getStorageStr('cart.aqty');
      if (aqty != null) {
        for (var i=0;i<cc.length;i++) {
          var a = utils.getAQty(cc[i].product_id);
          if (a > 0) {
            cc[i].cqty = a;
          }
        }
      }
      formdata.append('cart', JSON.stringify(cc));
      var url = utils.getServerPath()+'/cart/upd.is?a=u&product_id='+product_id;
      if (refresh != null) {
        url = url + "&refresh="+refresh;
      }
      Vue.http.post(url, formdata).then(response => {
        if (response.body.cart != null) {
          this.$root.$emit('cart', {'action':'updated', 'cart':response.body.cart});
        } else {
          this.$root.$emit('cart', {'action':'updated'});
        }
      });
    }
  },
  created: function() {
    var self = this;
    this.locale = utils.getLocale();
    try {
      this.products = utils.getCartStorage();
      var cc = this.products;
      var aqty = utils.getStorageStr('cart.aqty');
      if (aqty != null) {
        for (var i=0;i<cc.length;i++) {
          var a = utils.getAQty(cc[i].product_id);
          if (a > 0) {
            cc[i].cqty = a;
          }
        }
      }
      if (cc != null) {
        var url = 'upd.is?locale='+this.locale;
        var qtys = {};
        var formdata = new FormData();
        for (var i=0;i<cc.length;i++) {
          url = url + '&product_id='+cc[i].product_id;
          qtys[cc[i].product_id] = cc[i].oqty;
        }
        formdata.append('cart', JSON.stringify(cc));
        Vue.http.post(utils.getServerPath()+'/cart/'+url, formdata).then(response => {
          if (response.body.productlist != null && response.body.productlist.length > 0) {
            self.products = response.body.productlist;
            for (var i=0;i<self.products.length;i++) {
              self.products[i].oqty = qtys[self.products[i].pdetails.product_id];
              self.products[i].product_id = self.products[i].pdetails.product_id;
            }
          }
          //self.pagination = response.body.pagination;
          //self.pageno = parseInt(self.pagination.current_page / self.pagination.num);
          if (response.body.cart != null) {
            this.$root.$emit('cart', {'action':'created', 'cart':response.body.cart});
          } else {
            this.$root.$emit('cart', {'action':'created'});
          }
        });
      }
    } catch (e) {
      console.log(e);
    }
  },
  mounted: function() {
    this.$root.$on('notfound', data => {
      var product_id = this.products[data.idx].product_id;
      this.products.splice(data.idx, 1);
      this.save();
      //this.delItem(product_id);
    });
    this.$root.$on('remove', data => {
      if (data.all == true) {
        this.products = [];
        this.save();
        this.delAllItems();
      } else {
        var product_id = this.products[data.idx].product_id;
        this.products.splice(data.idx, 1);
        this.save();
        this.delItem(product_id);
      }
    });
    this.$root.$on('qty', data => {
      this.products[data.idx].oqty = data.oqty;
      this.save();
      if (data.oqty == 0) {
        this.delItem(this.products[data.idx].product_id);
        this.products.splice(data.idx, 1);
      } else {
        this.updItem(this.products[data.idx].product_id, data.refresh);
      }
    });
    this.$root.$on('loadcart', data => {
      this.getCart();
    });
    this.$root.$on('buy', data => {
      if (data) {
        var found = false;
        if (this.products != null) {
          if (data.idx != null && data.idx < this.products.length) {
            this.products[data.idx].oqty = data.oqty;
          } else {
            //for (var i=0;i<this.products.length;i++) {
            for (var i=this.products.length-1;i>=0;i--) {
              if ((this.products[i].product_id == data.details.pdetails.product_id) || (this.products[i].pdetails != null && this.products[i].pdetails.product_id == data.details.pdetails.product_id)) {
                if (data.add) {
                  this.products[i].oqty = this.products[i].oqty + data.oqty;
                } else {
                  this.products[i].oqty = data.oqty;
                }
                if (this.products[i].oqty == 0) {
                  this.delItem(this.products[i].product_id);
                  this.products.splice(i, 1);
                }
                found = true;
                break;
              }
            }
          }
        } else {
          this.products = [];
        }
        if (!found && data.oqty > 0) {
          this.products.push({"product_id":data.details.pdetails.product_id, "oqty":data.oqty});
        }
        this.save();
        if ('batch' != data.mode) {
          // no need to push to server if batch mode
          this.updItem(data.details.pdetails.product_id, data.refresh);
          this.$root.$emit('added', {"product_id":data.details.pdetails.product_id});
        }
      } else {
      }
    });
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ShoppingCart.vue